var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnboardingAttachment({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5815 3.75932L5.09637 9.39112C3.34401 11.1435 3.34397 13.9846 5.09633 15.7369C6.84869 17.4893 9.68983 17.4893 11.4422 15.7369L16.7909 10.4008C17.0415 10.1507 17.4474 10.1512 17.6975 10.4019C17.9475 10.6525 17.947 11.0584 17.6964 11.3084L12.3487 16.6435C12.3487 16.6436 12.3488 16.6434 12.3487 16.6435C10.0957 18.8963 6.44275 18.8965 4.18978 16.6435C1.93777 14.3915 1.93674 10.7409 4.1867 8.48761L9.672 2.85559C11.2575 1.27012 13.8281 1.27016 15.4135 2.85563C16.9979 4.44005 16.999 7.00825 15.4167 8.59397L9.93131 14.2261C9.0134 15.144 7.52515 15.1439 6.60725 14.226C5.68934 13.3081 5.68934 11.8199 6.60725 10.902L12.2361 5.27309C12.4865 5.02276 12.8924 5.02276 13.1427 5.27309C13.393 5.52343 13.393 5.92931 13.1427 6.17965L7.5138 11.8085C7.09657 12.2258 7.09657 12.9022 7.5138 13.3195C7.93015 13.7358 8.60463 13.7367 9.02207 13.3221L14.5069 7.69053C15.5917 6.60573 15.5918 4.84697 14.507 3.76218C13.4231 2.67834 11.6665 2.67738 10.5815 3.75932Z",
    fill: "#4B4F5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingAttachment);
export default __webpack_public_path__ + "static/media/onboarding-attachment.eea90d3cb68a52f1c8675b75ce35e4b4.svg";
export { ForwardRef as ReactComponent };